import { CsvProduct } from '../../components/BatchProductCreator/BatchProductCreator'
import { ZipFileResult } from '../types/batchProductCreator'

export const POST_ZIP_FILE = '[command] batch-product-creator/POST_ZIP_FILE'
export const POST_ZIP_FILE_SUCCESS = '[event] batch-product-creator/POST_ZIP_FILE_SUCCESS'
export const POST_ZIP_FILE_FAILURE = '[event] batch-product-creator/POST_ZIP_FILE_FAILURE'
export const SET_POST_ZIP_FILE_RESULT = '[document] batch-product-creator/SET_POST_ZIP_FILE_RESULT'

export const PARSE_CSV_FILE = '[command] batch-product-creator/PARSE_CSV_FILE'
export const PARSE_CSV_FILE_SUCCESS = '[event] batch-product-creator/PARSE_CSV_FILE_SUCCESS'
export const PARSE_CSV_FILE_FAILURE = '[event] batch-product-creator/PARSE_CSV_FILE_FAILURE'
export const SET_PARSE_CSV_FILE_RESULT =
  '[document] batch-product-creator/SET_PARSE_CSV_FILE_RESULT'
export const CLEAR = '[document] batch-product-creator/CLEAR'

// Commands
export const postZipFile = (payload: { zipFile: File }) => ({
  type: POST_ZIP_FILE,
  payload,
})

export const postCsvFile = (payload: { formData: FormData }) => ({
  type: PARSE_CSV_FILE,
  payload,
})

export const clear = () => ({
  type: CLEAR,
})

// Documents
export const setPostZipFileResult = (payload: { zipFileResult: ZipFileResult }) => {
  return {
    type: SET_POST_ZIP_FILE_RESULT,
    payload,
  }
}

export const setParseCsvFileResult = (payload: { csvFileResult: CsvProduct[] }) => {
  return {
    type: SET_PARSE_CSV_FILE_RESULT,
    payload,
  }
}
